import logo from "@/src/logo.svg";
import { Button } from "@/src/components/ui/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useFetch } from "@/src/lib/useFetch";
import { useToast } from "@/src/components/ui/use-toast";

export function LinkSent() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const state = useLocation().state;

  useEffect(() => {
    if (!state?.email || typeof state.email !== "string") {
      navigate("/login");
    }
  }, [state]);

  const email = (state.email as string | undefined) || "example email";
  const { fetch, isFetching } = useFetch();

  const onSend = async () => {
    fetch("/api/auth/login-link-request", "POST", { email })
      .then(() => {
        toast({
          title: "Link sent",
          description: `We've sent a login link to ${email}. Please check your inbox.`,
        });
      })
      .catch((err) => {
        console.error(err);
        navigate("/login/error");
      });
  };

  return (
    <div className="h-screen w-screen p-2 relative flex place-content-center bg-white">
      <img src={logo} className="absolute w-16 h-9 left-11 top-7"></img>
      <div className="flex flex-col items-center justify-center w-96">
        <h1 className="text-3xl font-semibold">Check your e-mail</h1>
        <span className="text-base mt-4 text-center">
          If you have an account associated with this e-mail, we’ll send you a
          temporary login link.
        </span>
        <span className="text-base mt-4">Please check your inbox at</span>
        <span className="text-base font-medium">{email}</span>
        <Button className="mt-12 w-full" disabled={isFetching} onClick={onSend}>
          Resend the link
        </Button>
        <Link className="mt-6 text-primary" to="/login">
          Back to Login
        </Link>
      </div>
    </div>
  );
}
